import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableSuppliersGrid = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableSuppliersGrid);
};
